import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import GlobalStyle from "./globalStyles";
import configureStore from "store";
import Routes from "routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { bootThirdParties } from "utils/thirdParty";
import { env } from "utils/env";
import ReactModal from "react-modal";

// Sentry must be initialized before any render calls so it can capture
// errors thrown during the first render pass.
Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  release: env.VITE_GIT_COMMIT,
  environment: env.VITE_STAGE || "development",
  tracesSampleRate: 0.05,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  sendDefaultPii: false,
});

// Third parties boot after Sentry so any error during their init is still
// captured, and are keyed to the landing route: a logged-out guest opening a
// public gallery gets only deferred, cookieless analytics. See
// utils/thirdParty for the per-SDK policy. (PostHog is a no-op without
// VITE_POSTHOG_KEY — feature-flag reads then default to the safe branch.)
bootThirdParties(window.location.pathname);

const store = configureStore();
const queryClient = new QueryClient();

ReactModal.setAppElement("#root");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <GlobalStyle />
          <Routes />
        </HelmetProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </Provider>
  </Sentry.ErrorBoundary>
);
